(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fm-abo-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fm-abo-intro')) {
  customElements.define('fm-abo-intro', class extends HTMLElement {
    connectedCallback() {
      if (this.listenerController) return;
      this.listenerController = new AbortController();
      const button = this.querySelector('.fm-abo-intro-motion');
      if (button) {
        button.hidden = false;
        button.addEventListener('click', () => {
          const paused = this.classList.toggle('is-paused');
          button.setAttribute('aria-pressed', String(paused));
          button.querySelector('[data-motion-label]').textContent = paused ? button.dataset.resume : button.dataset.pause;
          button.querySelector('[aria-hidden]').textContent = paused ? '▷' : 'Ⅱ';
        }, { signal: this.listenerController.signal });
      }
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => this.classList.toggle('is-in-view', entry.isIntersecting)), { threshold: 0.1 });
        this.observer.observe(this);
      } else this.classList.add('is-in-view');
    }
    disconnectedCallback() {
      this.observer?.disconnect();
      this.listenerController?.abort();
      this.listenerController = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-announcement"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fm-rotating-announcement')) {
  customElements.define('fm-rotating-announcement', class extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.slides = [...this.querySelectorAll('[data-banner-slide]')];
      if (this.slides.length < 2) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.index = Math.max(0, this.slides.findIndex(slide => slide.classList.contains('is-active')));
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reducedMotion.matches;
      this.hovered = false;
      this.focused = false;
      if (this.reducedMotion.matches) this.advance();
      this.addEventListener('keydown', event => {
        if (event.key === 'Escape') { this.paused = true; this.schedule(); }
      }, options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        this.hovered = true;
        this.schedule();
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.reducedMotion.addEventListener('change', event => {
        this.paused = event.matches;
        this.schedule();
      }, options);
      this.schedule();
    }
    schedule() {
      window.clearTimeout(this.timer);
      if (this.paused || this.hovered || this.focused || document.hidden) return;
      this.timer = window.setTimeout(() => { this.advance(); this.schedule(); }, 6500);
    }
    advance() {
      this.index = (this.index + 1) % this.slides.length;
      this.slides.forEach((slide, index) => {
        const active = index === this.index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.inert = !active;
      });
    }
    disconnectedCallback() {
      window.clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-business"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fm-business')) {
  customElements.define('fm-business', class extends HTMLElement {
    connectedCallback() {
      if (this.listenerController) return;
      this.listenerController = new AbortController();
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-business-choice]');
        if (!link) return;
        const target = document.getElementById(link.hash.slice(1));
        const field = target?.querySelector('[data-inquiry-key="interesse"]');
        if (!target || !field) return;
        const choiceIndex = Number(link.dataset.businessChoice);
        const choices = field.querySelectorAll('input[type="radio"]');
        const select = field.querySelector('select');
        const choice = choices[choiceIndex];
        if (choice) {
          choice.checked = true;
          choice.dispatchEvent(new Event('change', { bubbles: true }));
        } else if (select?.options[choiceIndex + 1]) {
          select.selectedIndex = choiceIndex + 1;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        } else return;
        event.preventDefault();
        const focusTarget = target.querySelector('input[name="contact[name]"]');
        focusTarget?.focus({ preventScroll: true });
        history.replaceState(null, '', link.hash);
        target.scrollIntoView({ behavior: 'instant', block: 'start' });
      }, { signal: this.listenerController.signal });
    }
    disconnectedCallback() {
      this.listenerController?.abort();
      this.listenerController = null;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-creator-program"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fm-creator-program')) {
  customElements.define('fm-creator-program', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', event => {
        const link = event.target.closest('[data-creator-route]');
        if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
        const target = document.getElementById('creator-bewerbung');
        const choices = target?.querySelectorAll('input[name="contact[creator-weg]"]');
        const choice = Array.from(choices || []).find(input => input.value === link.dataset.creatorRoute);
        if (!choice) return;
        choice.checked = true;
        choice.dispatchEvent(new Event('change', {bubbles:true}));
      }, {signal:this.controller.signal});
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-header"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fm-navigation')) {
  customElements.define('fm-navigation', class extends HTMLElement {
    connectedCallback() {
      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.panel = this.querySelector('.fm-header-menu-panel');
      if (!this.details || !this.summary) return;
      if (this.events) this.events.abort();
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      const sizePanel = () => {
        if (!this.details.open || !this.panel) return;
        const viewport = window.visualViewport;
        const bottom = viewport ? viewport.height + viewport.offsetTop : window.innerHeight;
        const top = this.panel.getBoundingClientRect().top;
        this.panel.style.setProperty('--fm-menu-max-height', `${Math.max(120, bottom - top - 16)}px`);
      };
      this.summary.setAttribute('aria-expanded', String(this.details.open));
      this.details.addEventListener('toggle', () => {
        this.summary.setAttribute('aria-label', this.details.open ? this.summary.dataset.closeLabel : this.summary.dataset.openLabel);
        this.summary.setAttribute('aria-expanded', String(this.details.open));
        if (this.details.open) window.requestAnimationFrame(sizePanel);
      }, options);
      this.addEventListener('keydown', event => {
        if (event.key === 'ArrowDown' && event.target === this.summary) {
          event.preventDefault();
          this.details.open = true;
          this.panel.querySelector('a, summary')?.focus();
        }
        if (event.key === 'Escape' && this.details.open) {
          event.preventDefault();
          const child = event.target.closest('.fm-menu-category[open], .fm-menu-subcategory[open]');
          if (child) {
            child.open = false;
            child.querySelector('summary').focus();
            event.stopPropagation();
            return;
          }
          this.details.open = false;
          this.summary.focus();
          event.stopPropagation();
        }
      }, options);
      this.addEventListener('click', event => {
        if (event.target.closest('nav a')) window.setTimeout(() => { this.details.open = false; }, 0);
      }, options);
      document.addEventListener('click', event => {
        if (this.details.open && !this.contains(event.target)) this.details.open = false;
      }, options);
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.details.open = false;
      }, options);
      window.addEventListener('resize', sizePanel, options);
      if (window.visualViewport) window.visualViewport.addEventListener('resize', sizePanel, options);
    }
    disconnectedCallback() {
      if (this.events) this.events.abort();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-media"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fm-media-carousel')) {
    customElements.define('fm-media-carousel', class extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-media-track]');
        this.previous = this.querySelector('[data-media-prev]');
        this.next = this.querySelector('[data-media-next]');
        this.controls = this.querySelector('[data-media-controls]');
        if (!this.track || !this.previous || !this.next) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        this.update = () => {
          const maximum = this.track.scrollWidth - this.track.clientWidth;
          this.controls.hidden = maximum < 3;
          this.previous.disabled = this.track.scrollLeft < 3;
          this.next.disabled = this.track.scrollLeft >= maximum - 3;
        };
        const move = direction => {
          const card = this.track.querySelector('.fm-media-tile');
          const distance = card ? card.getBoundingClientRect().width + parseFloat(getComputedStyle(this.track).gap || 0) : this.track.clientWidth;
          this.track.scrollBy({ left: direction * distance, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.previous.addEventListener('click', () => move(-1), options);
        this.next.addEventListener('click', () => move(1), options);
        this.track.addEventListener('scroll', this.update, { passive: true, signal: this.abort.signal });
        this.track.addEventListener('keydown', event => {
          if (event.target !== this.track) return;
          if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
            event.preventDefault();
            move(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.videos = Array.from(this.track.querySelectorAll('video'));
        this.videoObserver = new IntersectionObserver(entries => {
          entries.forEach(({ target: video, isIntersecting }) => {
            if (isIntersecting && !document.hidden) {
              video.play()?.catch(() => {});
            } else {
              video.pause();
            }
          });
        }, { threshold: 0.1 });
        this.videos.forEach(video => {
          video.muted = true;
          video.playsInline = true;
          this.videoObserver.observe(video);
        });
        this.resize = new ResizeObserver(this.update);
        this.resize.observe(this.track);
        this.update();
      }
      disconnectedCallback() {
        this.abort?.abort();
        this.resize?.disconnect();
        this.videoObserver?.disconnect();
        this.videos?.forEach(video => video.pause());
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-next-drop"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fm-next-drop')) {
    customElements.define('fm-next-drop', class extends HTMLElement {
      connectedCallback() {
        if (this.bound) return;
        this.bound = true;
        const select = this.querySelector('[data-drop-select]');
        const email = this.querySelector('[data-drop-email]');
        if (!select || !email) return;
        const storageKey = 'fm-drop-choice-' + this.querySelector('form').id;
        try {
          if (this.querySelector('[data-drop-success]')) sessionStorage.removeItem(storageKey);
          else {
            const saved = sessionStorage.getItem(storageKey);
            if (saved && Array.from(select.options).some(option => option.value === saved)) select.value = saved;
          }
        } catch {}
        const markSelection = () => {
          this.querySelectorAll('[data-drop-scent]').forEach(link => {
            link.closest('.fm-drop-card').dataset.selected = String(link.dataset.dropScent === select.value);
          });
        };
        const saveSelection = () => {
          markSelection();
          try { sessionStorage.setItem(storageKey, select.value); } catch {}
        };
        this.querySelectorAll('[data-drop-reveal]').forEach(button => { button.disabled = false; });
        this.addEventListener('click', event => {
          const reveal = event.target.closest('[data-drop-reveal]');
          if (reveal) {
            const revealed = reveal.getAttribute('aria-pressed') !== 'true';
            const label = revealed ? reveal.dataset.hideLabel : reveal.dataset.revealLabel;
            reveal.setAttribute('aria-pressed', String(revealed));
            reveal.setAttribute('aria-label', reveal.dataset.scentName + ' – ' + label);
            reveal.querySelector('[data-drop-reveal-hint]').textContent = label;
            return;
          }
          const link = event.target.closest('[data-drop-scent]');
          if (!link || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          select.value = link.dataset.dropScent;
          saveSelection();
          email.focus({ preventScroll: true });
          this.querySelector('.fm-drop-waitlist').scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        });
        select.addEventListener('change', saveSelection);
        markSelection();
        if ('IntersectionObserver' in window) {
          const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) {
              this.classList.add('is-visible');
              observer.disconnect();
            }
          }, { threshold: 0.35 });
          observer.observe(this.querySelector('.fm-drop-heading'));
        } else this.classList.add('is-visible');
        const status = this.querySelector('[data-drop-status]');
        if (status && window.location.hash === '#' + this.querySelector('form').id) status.focus();
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-offers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fm-floating-offers')) {
  customElements.define('fm-floating-offers', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.listenerController = new AbortController();
      const button = this.querySelector('.fm-offer-motion');
      if (button) button.addEventListener('click', () => {
        const paused = this.classList.toggle('fm-motion-paused');
        button.setAttribute('aria-pressed', String(paused));
        button.querySelector('[data-motion-label]').textContent = paused ? button.dataset.motionResume : button.dataset.motionPause;
        button.querySelector('[aria-hidden]').textContent = paused ? '▷' : 'Ⅱ';
      }, { signal: this.listenerController.signal });
      const artwork = this.querySelectorAll('.fm-offer-art');
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => entries.forEach(entry => entry.target.classList.toggle('is-in-view', entry.isIntersecting)), { threshold: 0.1 });
        artwork.forEach(item => this.observer.observe(item));
      } else artwork.forEach(item => item.classList.add('is-in-view'));
    }
    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
      if (this.listenerController) this.listenerController.abort();
      this.initialized = false;
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-order-service"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('fm-order-finder')) {
  customElements.define('fm-order-finder', class extends HTMLElement {
    connectedCallback() {
      if (this.bound) return;
      this.bound = true;
      this.key = 'fm-order-lookup';
      this.input = this.querySelector('[data-order-number]');
      this.status = this.querySelector('[data-order-status]');
      this.authenticated = this.dataset.authenticated === 'true';
      this.cards = [...this.querySelectorAll('[data-order-card]')];
      this.querySelector('[data-order-search]').addEventListener('submit', event => {
        event.preventDefault();
        const query = this.input.value.trim().slice(0, 60);
        const saved = this.save({query, searching: true});
        if (!this.authenticated) {
          window.location.assign(this.dataset.loginUrl);
          return;
        }
        const page = Number(this.querySelector('[data-orders-page]')?.dataset.ordersPage || 1);
        if (page > 1 && saved) window.location.assign(this.dataset.firstUrl);
        else this.search(query, saved);
      });
      const pending = this.read();
      if (pending?.query) {
        this.input.value = pending.query;
        if (this.authenticated) this.search(pending.query, pending.searching === true);
      }
    }
    normalize(value) { return String(value || '').trim().toLocaleLowerCase().replace(/^#/, '').replace(/\s/g, ''); }
    read() { try { return JSON.parse(sessionStorage.getItem(this.key)); } catch { return null; } }
    save(value) { try { sessionStorage.setItem(this.key, JSON.stringify(value)); return true; } catch { return false; } }
    search(query, followPages) {
      const normalized = this.normalize(query);
      let found = 0;
      this.cards.forEach(card => {
        const match = !normalized || this.normalize(card.dataset.orderName) === normalized || this.normalize(card.dataset.orderNumber) === normalized;
        card.hidden = !match;
        if (match) found++;
      });
      if (!normalized) {
        this.status.textContent = '';
        this.save({query:'', searching:false});
        return;
      }
      if (found) {
        this.status.textContent = this.dataset.found;
        this.save({query, searching:false});
        return;
      }
      const next = this.querySelector('[data-orders-next]');
      if (followPages && next && this.save({query, searching:true})) {
        this.status.textContent = this.dataset.paging;
        window.location.assign(next.href);
        return;
      }
      this.status.textContent = this.dataset.none;
      this.save({query, searching:false});
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-scent-playground"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('fm-scent-playground')) {
 customElements.define('fm-scent-playground',class extends HTMLElement {
  connectedCallback(){
   if(this.controller)return;
   this.controller=new AbortController();const signal=this.controller.signal;
   this.cards=Array.from(this.querySelectorAll('.fm-dream-scent:not(.fm-dream-scent--soon)'));this.active=0;this.visible=false;
   this.reduce=window.matchMedia('(prefers-reduced-motion: reduce)');
   this.cards.forEach((card,index)=>card.querySelector('button').addEventListener('click',()=>{this.select(index);this.sync();},{signal}));
   document.addEventListener('visibilitychange',()=>this.sync(),{signal});
   this.reduce.addEventListener('change',()=>this.sync(),{signal});
   this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;this.sync();},{threshold:.04});this.observer.observe(this);this.sync();
  }
  select(index){this.active=index;this.cards.forEach((card,i)=>{const active=i===index;card.classList.toggle('is-active',active);card.querySelector('button').setAttribute('aria-pressed',String(active));card.querySelector('.fm-dream-bubble').setAttribute('aria-hidden',String(!active));});}
  sync(){clearInterval(this.timer);const animate=this.dataset.auto==='true'&&this.visible&&!document.hidden&&!this.reduce.matches;this.dataset.motion=animate?'on':'off';if(animate&&this.cards.length>1)this.timer=setInterval(()=>{if(!this.contains(document.activeElement))this.select((this.active+1)%this.cards.length);},5200);}
  disconnectedCallback(){clearInterval(this.timer);this.observer?.disconnect();this.controller?.abort();this.controller=null;}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-scent-quiz"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fm-scent-quiz'))customElements.define('fm-scent-quiz',class extends HTMLElement{
 connectedCallback(){if(this.ready)return;this.ready=true;this.step=0;this.answers=[];this.questions=[...this.querySelectorAll('[data-question]')];this.addEventListener('click',e=>{const answer=e.target.closest('[data-score]');if(answer){this.answers[this.step]=Number(answer.dataset.score);this.step++;this.show();}if(e.target.closest('[data-back]')){this.step=Math.max(0,this.step-1);this.show();}if(e.target.closest('[data-restart]')){this.step=0;this.answers=[];this.show();}});}
 show(){const done=this.step===3;this.querySelector('[data-quiz-questions]').hidden=done;this.querySelector('[data-quiz-results]').hidden=!done;this.querySelector('[data-step-count]').textContent=done?'Dein Duft-Match ♡':`Frage ${this.step+1} von 3`;this.querySelectorAll('.fm-quiz-dots i').forEach((dot,i)=>dot.classList.toggle('active',i<=this.step));if(done){const scores=[0,0,0,0];this.answers.forEach((a,i)=>scores[a]+=[1,2,1][i]);const max=Math.max(...scores);const winner=scores[this.answers[1]]===max?this.answers[1]:scores.indexOf(max);this.querySelectorAll('[data-result]').forEach(el=>el.hidden=Number(el.dataset.result)!==winner);this.querySelector(`[data-result="${winner}"] h2`).focus({preventScroll:true});}else{this.questions.forEach((q,i)=>q.hidden=i!==this.step);this.querySelector('[data-back]').hidden=this.step===0;this.questions[this.step].querySelector('legend').focus({preventScroll:true});}}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-subscriptions"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('fm-subscriptions')) {
    class FemoraSubscriptions extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;
        this.form = this.querySelector('form');
        this.submitButton = this.querySelector('[data-abo-submit]');
        this.scents = Array.from(this.querySelectorAll('[data-abo-scent]'));
        this.sequence = [];
        this.monthRows = [];
        this.form.addEventListener('change', (event) => {
          if (event.target.matches('[data-abo-month-select]')) this.sequence[Number(event.target.dataset.aboMonthSelect)] = event.target.value;
          this.render();
        });
        this.form.addEventListener('submit', (event) => {
          if (!this.render()) event.preventDefault();
        });
        this.render();
      }
      money(cents) {
        return new Intl.NumberFormat(document.documentElement.lang || 'de-DE', {style:'currency', currency:this.dataset.currency || 'EUR'}).format(cents / 100);
      }
      template(text, values) {
        return Object.entries(values).reduce((result, [key,value]) => result.split('[' + key + ']').join(value), text || '');
      }
      allocation(scent, plan) {
        if (!scent || !plan?.dataset.sellingPlanName) return null;
        let allocations = [];
        try { allocations = JSON.parse(scent.dataset.allocations || '[]'); } catch { return null; }
        return allocations.find(item => item.name === plan.dataset.sellingPlanName && item.id && Number(item.price) === Number(plan.dataset.price) * Number(plan.dataset.months) && Number(item.checkoutCharge) === Number(item.price) && Number(item.perDelivery) === Number(plan.dataset.price)) || null;
      }
      monthLabel(index) {
        return this.template(this.dataset.monthLabel, {month:index + 1});
      }
      createMonth(index) {
        const row = document.createElement('div');row.className = 'fm-abo-month';
        const top = document.createElement('div');top.className = 'fm-abo-month-top';
        const image = document.createElement('img');image.width = 42;image.height = 48;image.alt = '';image.loading = 'lazy';
        const label = document.createElement('label');label.textContent = this.monthLabel(index);
        const select = document.createElement('select');select.id = 'fm-abo-month-' + this.dataset.sectionId + '-' + index;select.dataset.aboMonthSelect = String(index);label.htmlFor = select.id;
        this.scents.forEach(scent => { const option = document.createElement('option');option.value = scent.value;option.textContent = scent.dataset.title;select.appendChild(option); });
        top.append(image,label);row.append(top,select);this.querySelector('[data-abo-months]').appendChild(row);
        this.monthRows.push({row,image,select});
        return this.monthRows[index];
      }
      renderSequence(months, plan, cents, visible) {
        const available = this.scents.filter(scent => scent.dataset.available === 'true' && (this.dataset.enabled !== 'true' || Number(this.allocation(scent,plan)?.perDelivery) === cents));
        for (let index = 0; index < months; index++) {
          if (!this.sequence[index]) this.sequence[index] = available[index % available.length]?.value || this.scents[0]?.value || '';
          const {row,image,select} = this.monthRows[index] || this.createMonth(index);
          row.hidden = false;select.disabled = !visible;select.value = this.sequence[index];
          const scent = this.scents.find(item => item.value === this.sequence[index]);
          Array.from(select.options).forEach(option => {option.disabled = !available.some(item => item.value === option.value);});
          select.setAttribute('aria-invalid', String(!available.some(item => item.value === this.sequence[index])));
          image.hidden = !scent?.dataset.image;
          if (scent?.dataset.image && image.getAttribute('src') !== scent.dataset.image) image.src = scent.dataset.image;
        }
        this.monthRows.slice(months).forEach(({row,select}) => {row.hidden = true;select.disabled = true;});
        return this.sequence.slice(0,months).map(id => this.scents.find(scent => scent.value === id));
      }
      render() {
        const single = this.querySelector('[data-abo-scent]:checked');
        const plan = this.querySelector('[data-abo-plan]:checked');
        const active = this.dataset.enabled === 'true';
        const sequenceEnabled = this.dataset.sequenceEnabled === 'true';
        const custom = sequenceEnabled && this.querySelector('[data-abo-mode]:checked')?.value === 'sequence';
        const integrationReady = this.dataset.sequenceReady === 'true';
        const months = Math.min(24,Math.max(1,Number(plan?.dataset.months) || 1));
        const reference = custom ? this.scents.find(scent => scent.value === this.sequence[0]) || this.scents.find(scent => scent.dataset.available === 'true' && this.allocation(scent,plan)) || single : single;
        const allocation = this.allocation(reference,plan);
        const cents = Number(plan?.dataset.price) || 0;
        let chosen = [single];
        if (sequenceEnabled) {
          const sequence = this.renderSequence(months,plan,cents,custom);
          if (custom) chosen = sequence;
          this.querySelector('[data-abo-sequence-panel]').hidden = !custom;
          this.querySelector('[data-abo-sequence-status]').hidden = !custom;
          this.querySelector('[data-abo-sequence-preview]').hidden = integrationReady;
          this.querySelector('[data-abo-sequence-renewal-preview]').hidden = integrationReady;
          this.querySelector('[data-abo-sequence-renewal-ready]').hidden = !integrationReady;
        }
        this.querySelector('[data-abo-single-panel]').hidden = custom;
        this.querySelectorAll('[data-abo-plan]').forEach(item => {
          const actual = this.allocation(reference,item);
          item.closest('.fm-abo-plan').querySelector('[data-abo-plan-price]').textContent = this.money(actual ? Number(actual.price) : Number(item.dataset.price) * Number(item.dataset.months));
        });
        const valid = Boolean(plan && allocation && cents > 0 && chosen.length && chosen.every(scent => scent?.dataset.available === 'true' && this.allocation(scent,plan)?.id === allocation.id && Number(this.allocation(scent,plan)?.perDelivery) === cents));
        const ready = active && valid && (!custom || integrationReady);
        const minimum = cents * months;
        const base = custom ? chosen.reduce((sum,scent) => sum + (Number(scent?.dataset.basePrice) || 0),0) : (Number(single?.dataset.basePrice) || 0) * months;
        const savings = Math.max(0,base - minimum);
        const percent = base > 0 ? Math.round(savings / base * 100) : 0;
        this.querySelector('[data-abo-title]').textContent = custom ? this.dataset.sequenceTitle : single?.dataset.title || this.dataset.emptyTitle;
        const summaryImage = this.querySelector('[data-abo-summary-image]');
        summaryImage.hidden = custom || !single?.dataset.image;
        if (!summaryImage.hidden && summaryImage.getAttribute('src') !== single.dataset.image) summaryImage.src = single.dataset.image;
        this.querySelector('[data-abo-term]').textContent = plan ? this.template(this.dataset.termTemplate,{months,title:plan.dataset.title}) : '';
        this.querySelector('[data-abo-price]').textContent = plan ? this.money(minimum) : '—';
        this.querySelector('[data-abo-minimum]').textContent = plan ? this.money(cents) : '—';
        this.querySelector('[data-abo-savings]').textContent = valid && savings > 0 ? this.template(this.dataset.savingsTemplate,{savings:this.money(savings),months,percent}) : '';
        this.querySelector('[data-abo-unit]').textContent = plan ? this.template(this.dataset.unitTemplate,{price:this.money(cents * 1000 / (Number(this.dataset.volume) || 30)),volume:this.dataset.volume}) : '';
        const summary = this.querySelector('[data-abo-sequence-summary]');summary.hidden = !custom;summary.replaceChildren();this.querySelector('[data-abo-month-overview]').hidden=!custom;
        if (custom) chosen.forEach((scent,index) => {const item = document.createElement('li'),month = document.createElement('span'),name = document.createElement('span');month.textContent = this.monthLabel(index);name.textContent = scent?.dataset.title || this.dataset.emptyTitle;item.append(month,name);summary.appendChild(item);});
        if (sequenceEnabled) this.querySelector('[data-abo-sequence-error]').textContent = custom && !valid ? this.dataset.sequenceInvalid : '';
        const properties = this.querySelector('[data-abo-properties]');properties.replaceChildren();
        if (ready) {
          const appendProperty = (key,value) => {const input = document.createElement('input');input.type = 'hidden';input.name = 'properties[' + key + ']';input.value = value;properties.appendChild(input);};
          appendProperty(this.dataset.cartTerm,plan.dataset.title);
          appendProperty(this.dataset.cartPayment,this.dataset.cartPaymentValue);
          appendProperty('_fm_prepaid','true');
          appendProperty('_fm_term_months',String(months));
          if(custom){chosen.forEach((scent,index) => appendProperty(this.monthLabel(index),scent.dataset.title));appendProperty('_fm_sequence',JSON.stringify({version:2,variantIds:chosen.map(scent => scent.value),repeat:false}));}
        }
        this.form.elements.id.value = ready ? chosen[0].value : '';
        this.form.elements.id.disabled = !ready;
        this.form.elements.selling_plan.value = ready ? allocation.id : '';
        this.form.elements.selling_plan.disabled = !ready;
        this.submitButton.disabled = !ready;
        this.submitButton.textContent = custom && !integrationReady ? this.dataset.sequenceButton : ready ? this.dataset.buttonLabel : active ? this.dataset.unavailableLabel : this.dataset.comingLabel;
        return ready;
      }
    }
    customElements.define('fm-subscriptions',FemoraSubscriptions);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fm-welcome-popup"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('fm-welcome-popup')){
class FemoraWelcomePopup extends HTMLElement{
connectedCallback(){
if(this.initialized)return;this.initialized=true;this.dialog=this.querySelector('dialog');this.key='femora-community-welcome-v3';
this.dock=this.querySelector('[data-community-dock]');this.dismissKey='femora-community-tab-dismissed';
try{this.dock.hidden=sessionStorage.getItem(this.dismissKey)==='1';}catch{}
this.querySelector('[data-community-dismiss]').addEventListener('click',()=>{this.dock.hidden=true;try{sessionStorage.setItem(this.dismissKey,'1');}catch{}});
this.querySelector('[data-community-open]').addEventListener('click',()=>{this.show();this.openEmail(true);});
this.querySelector('[data-open-email]').addEventListener('click',()=>this.openEmail(true));
this.querySelectorAll('[data-welcome-close]').forEach(b=>b.addEventListener('click',()=>this.dialog.close()));
this.querySelectorAll('[data-welcome-scent]').forEach(input=>input.addEventListener('change',()=>{const tags=this.querySelector('[data-welcome-tags]');if(tags)tags.value='newsletter,femora-welcome,femora-community,femora-pref-'+input.value;}));
this.querySelector('form')?.addEventListener('submit',event=>{if(this.dataset.ready!=='true')event.preventDefault();});
this.dialog.addEventListener('close',()=>{this.remember();if(this.previousFocus?.isConnected)this.previousFocus.focus({preventScroll:true});});
this.dialog.addEventListener('click',e=>{if(e.target===this.dialog){const b=this.dialog.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)this.dialog.close();}});
if(this.dataset.editor==='true'){this.editorHandler=e=>{if(e.target.contains(this))this.show();};document.addEventListener('shopify:section:select',this.editorHandler);return;}
if(this.querySelector('[data-welcome-success],[data-welcome-errors]')){this.openEmail(false);this.show();return;}

}
openEmail(focus){this.querySelector('.fm-welcome-reward').hidden=false;this.dialog.classList.add('is-email');this.querySelector('[data-open-email]').setAttribute('aria-expanded','true');if(focus)this.querySelector('input[type=email]')?.focus({preventScroll:true});}
show(){if(!this.dialog.open){this.previousFocus=document.activeElement;this.dialog.showModal();this.remember();}}
remember(){try{sessionStorage.setItem(this.key,'1');}catch{}}
disconnectedCallback(){clearTimeout(this.timer);if(this.editorHandler)document.removeEventListener('shopify:section:select',this.editorHandler);}
}customElements.define('fm-welcome-popup',FemoraWelcomePopup);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.isManagedByGroup = false;

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Check if managed by StickyGroupManager (set after manager initializes)
      // Use MutationObserver to detect when managedByGroup attribute is set
      this.checkManagedStatus();

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      // Listen for sticky events from StickyGroupManager
      this.addEventListener('stickyHide', this.onManagedHide.bind(this));
      this.addEventListener('stickyReveal', this.onManagedReveal.bind(this));
      this.addEventListener('stickyReset', this.onManagedReset.bind(this));

      // Only attach scroll handler if not managed by group
      if (!this.isManagedByGroup) {
        this.onScrollHandler = this.onScroll.bind(this);
        window.addEventListener('scroll', this.onScrollHandler, false);
        this.createObserver();
      }
    }

    checkManagedStatus() {
      // Check if already managed
      if (this.dataset.managedByGroup === 'true') {
        this.isManagedByGroup = true;
        return;
      }

      // Watch for the attribute to be set by the manager
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (mutation.attributeName === 'data-managed-by-group' && this.dataset.managedByGroup === 'true') {
            this.isManagedByGroup = true;
            // Remove scroll handler if it was attached
            if (this.onScrollHandler) {
              window.removeEventListener('scroll', this.onScrollHandler);
            }
            observer.disconnect();
          }
        });
      });

      observer.observe(this, { attributes: true });
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      if (this.onScrollHandler) {
        window.removeEventListener('scroll', this.onScrollHandler);
      }
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      // Skip if managed by group
      if (this.isManagedByGroup) return;

      const scrollTop = window.scrollY || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    // Event handlers for when managed by StickyGroupManager
    onManagedHide() {
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    onManagedReveal() {
      // Any reveal-specific logic
    }

    onManagedReset() {
      // Any reset-specific logic
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal?.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);
  
  class StaticHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }
  }

  customElements.define('static-header', StaticHeader);

  } catch(e) { console.error(e); }
})();
})();
